var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('scale-loader',{attrs:{"loading":"loading","color":"red","height":"40px","width":"8px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }